import { ArrayNotEmpty, IsArray, IsInt, IsISO8601, IsOptional, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';


class StartEndDateDto {
  @IsOptional()
  @IsISO8601()
  startDate: string;

  @IsOptional()
  @IsISO8601()
  endDate: string;
}

export class GetSuppliersWithOrdersDto {
  @IsArray()
  @ArrayNotEmpty()
  @IsInt({ each: true })
  orderStatusIds: number[];

  @IsOptional()
  @ValidateNested()
  @Type(() => StartEndDateDto)
  orderDateFilter: StartEndDateDto

  @IsOptional()
  @ValidateNested()
  @Type(() => StartEndDateDto)
  deliveryDateFilter: StartEndDateDto
}
